import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';
import ConfirmationModal from './ConfirmationModal';

class ModalWithSubmitConfirm extends Component {
  state = {
    showConfirm: false,
  };

  onCloseModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  onConfirmModal = () => {
    const { onConfirmValidation } = this.props;
    if (onConfirmValidation()) {
      this.setState({
        showConfirm: true,
      });
    }
  };

  onCloseConfirm = () => {
    this.setState((prevState) => ({
      showConfirm: !prevState.showConfirm,
    }));
  };

  onSubmitModal = async () => {
    const { onClose, onSubmitConfirm } = this.props;
    await onSubmitConfirm();
    onClose();
  };

  getModalButtons = () => {
    return [
      {
        name: 'send',
        text: 'buttonSend',
        action: this.onConfirmModal,
      },
      {
        name: 'close',
        text: 'buttonClose',
      },
    ];
  };

  render() {
    const { showConfirm } = this.state;
    const { isOpen, loadingOnConfirmCancel, className, labelConfirm } = this.props;
    return (
      <Fragment>
        <Modal {...this.props} isOpen={!showConfirm && isOpen} onClose={this.onCloseModal} backDrop={false} className={className} buttons={this.getModalButtons()} />
        <ConfirmationModal
          isOpen={showConfirm}
          type="warning"
          onClose={this.onCloseConfirm}
          onConfirm={this.onSubmitModal}
          loadingOnConfirm={loadingOnConfirmCancel}
          labelConfirm={labelConfirm}
          textBtnConfirm="buttonConfirm"
          className={className}
        />
      </Fragment>
    );
  }
}

ModalWithSubmitConfirm.defaultProps = {
  loadingOnConfirmCancel: true,
};

ModalWithSubmitConfirm.propTypes = {
  loadingOnConfirmCancel: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitConfirm: PropTypes.func.isRequired,
  onConfirmCancel: PropTypes.func.isRequired,
  onConfirmValidation: PropTypes.func.isRequired,
};

export default ModalWithSubmitConfirm;
